<template>
	<v-layout column justify-end >
		<v-flex >
			<v-bottom-nav style="z-index: 30; "
			:style="showNav ? 'background-color: lightgrey;' : 'background-color: white;' "
				:value="selectedRoom"
				
				absolute
				:height="navHeight">
				<v-layout v-if="selectedRoom" column >
					<v-flex class="text-xs-center" style="position: absolute; width: 100%; top: -49px; z-index: 100;">
						<v-btn icon class="collapseButton" style="color: darkgrey;" >
							<v-icon @click="toggleNavHeight" 
								large 
								class="collapseIcon">
							{{showNav ? 'expand_more' : 'expand_less'}}
							</v-icon>
						</v-btn>
					</v-flex>	

					<v-flex :class="showNav ? 'bottomContent' : ''">
						<v-flex xs12 v-show="!showNav" class="pt-2 pl-4 text-xs-left body-2"> ROOM </v-flex>	
						<BottomNavigationContent v-if="showNav" />		        			
					</v-flex>
					
				</v-layout>

				
			</v-bottom-nav>
		</v-flex>
	</v-layout>
</template>

<script>
import {mapState} from 'vuex'
import BottomNavigationContent from './BottomNavigationContent'

	export default {
		data () {
			return {
				activeBtn: 1,
				showNav: false,
				vw : window.innerWidth,
				vh : window.innerHeight,
			}
		},

		components: { BottomNavigationContent, },

		computed: {
			...mapState({ 	selectedRoom: state => state.space.selectedRoom, 
			}),

			navHeight: function () {
				return this.showNav ? this.vh-140 : 100 // was  / 37
			},

		},

		methods: {
			toggleNavHeight: function () {
				this.showNav=(!this.showNav)				
			},
		},
	}
</script>

<style>
.bottomContent {   
overflow-y:auto; 
overflow-x:hidden;       
}

.navBoxShadow {
-webkit-box-shadow: inset 0px 0px 15px 0px rgba(0,0,0,0.75);
-moz-box-shadow: inset 0px 0px 15px 0px rgba(0,0,0,0.75);
box-shadow: inset 0px 0px 15px 0px rgba(0,0,0,0.75);
}

</style>



// WEBPACK FOOTER //
// src/components/BottomNavigation.vue